import React from 'react';

import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from '@material-ui/core';

import ExpressionDialog from '@/client/components/ExpressionDialog';
import { PRIZE_STATUS } from './constants';

export const EntryDialog = ({ open, onClick, config }) => {
  const { redeemDate } = config;
  return (
    <ExpressionDialog open={open} expressionImage="">
      <DialogContent style={{ paddingTop: 16 }}>
        <Typography variant="body1" paragraph>
          <span role="img" aria-label="notice">
            ❗️❗️注意事項❗️❗️
          </span>
        </Typography>
        <Typography variant="body2" color="textSecondary" display="inline">
          1. 本活動所贈送之LINE Points將以LINE POINT CODE兌換網址形式回饋，請得獎者務必於
        </Typography>
        <Typography variant="body2" display="inline" style={{ color: '#FF0000', backgroundColor: '#FFFF00' }}>
          {redeemDate}
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ whiteSpace: 'pre-line' }} display="inline">
          {`前兌獎完畢；未兌獎致序號自動失效，將視同放棄。
          2. 本活動回饋之LINE Points不得要求兌換現金或其他等值商品，亦不得轉讓、販賣、由他人領獎。
          3. 本活動之參加者或得獎者不得有侵害他人權利（包括但不限於使用自動化程式影響抽獎結果等）或違反法令之情事，如有違反，主辦單位得取消參加或得獎資格並追回獎品。
          4. 如有任何因電腦、網路、電話、技術或不可歸責於主辦單位之事由，而使參加者所傳送或登錄之資料有遲延、遺失、錯誤等之情況，主辦單位不負任何法律責任，參加者亦不得因此異議。
          5. 主辦單位保有隨時變更本活動內容、終止與本活動參加資格之權利，及改由其他等值贈品取代之權利。本活動如有變更或終止時，將另行公告。若有其他未盡事宜，悉依主辦單位相關規定或解釋辦理。
          `}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button color="primary" onClick={onClick}>
          好
        </Button>
      </DialogActions>
    </ExpressionDialog>
  );
};

export const AnswerDialog = ({ open, isCorrect, isFinal, question, config, onClick }) => {
  const { id } = config;
  const img = `https://cdn.deepq.app/linebot-cdc/images/disease_quiz/answer_${
    isCorrect ? 'correct' : 'wrong'
  }-${id}.jpg`;
  const { explanation, options, answer } = question;

  return (
    <Dialog open={open} PaperProps={{ square: true }}>
      <Box>
        <img src={img} width="100%" alt="correctness" />
      </Box>
      <DialogContent style={{ paddingTop: 16 }}>
        <Typography variant="body1" paragraph>
          正確答案: {options[answer]}
        </Typography>
        <Typography variant="body2" color="textSecondary" style={{ whiteSpace: 'pre-line' }}>
          {explanation}
        </Typography>
      </DialogContent>
      <DialogActions>
        {isFinal ? (
          <Button variant="contained" color="primary" onClick={onClick} style={{ color: '#FFFFFF' }}>
            完成測驗，開始抽獎
          </Button>
        ) : (
          <Button color="primary" onClick={onClick}>
            下一題
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export const PrizeDialog = ({ open, status, onClick, config }) => {
  const { id, name } = config;
  let title = '';
  let description = '';
  let expressionImage = '';
  let buttonText = '關閉';

  switch (status) {
    case PRIZE_STATUS.PRIZE_MISSED:
      title = '嗚嗚沒有中獎';
      description = `好可惜，就差一點點就中獎了。但你擁有滿滿的${name}知識🤓`;
      expressionImage = `https://cdn.deepq.app/linebot-cdc/images/disease_quiz/sad_popout-${id}.png`;
      break;
    case PRIZE_STATUS.PRIZE_RECEIVED:
      title = '恭喜你獲得LINE POINT 5點';
      description = '趕快按下方按鈕進行領取喔！👇';
      expressionImage = `https://cdn.deepq.app/linebot-cdc/images/disease_quiz/happy_popout-${id}.png`;
      buttonText = '立即領取';
      break;
    case PRIZE_STATUS.PRIZE_DRAWN:
      title = '已參加過抽獎囉！';
      description = '每人只有一次抽獎機會，你已參加過囉！';
      expressionImage = `https://cdn.deepq.app/linebot-cdc/images/disease_quiz/questionable_popout-${id}.png`;
      break;
    case PRIZE_STATUS.PRIZE_FULL:
      title = '抽獎活動已結束';
      description = '很抱歉，目前抽獎活動已結束，下次手腳要快哦！';
      expressionImage = `https://cdn.deepq.app/linebot-cdc/images/disease_quiz/sad_popout-${id}.png`;
      break;
    default:
      title = '系統忙碌中';
      description = '很抱歉，系統忙碌中，請再試一次。';
      expressionImage = `https://cdn.deepq.app/linebot-cdc/images/disease_quiz/sad_popout-${id}.png`;
      break;
  }
  return (
    <ExpressionDialog open={open} expressionImage={expressionImage}>
      <DialogContent style={{ paddingTop: 16 }}>
        <Typography variant="body1" paragraph>
          {title}
        </Typography>
        <Typography variant="body2" color="textSecondary">
          {description}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button style={{ color: '#036EB8' }} onClick={onClick}>
          {buttonText}
        </Button>
      </DialogActions>
    </ExpressionDialog>
  );
};
